import { ITextField, ITextFieldProps, TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';

/**
 * When a multiline TextField component mounts in I.E/ firefox/ Safari the cursor
 * is placed at the beginning of the field, so we move it to the end on mount
 */
class WithCursorAtEnd extends React.Component<ITextFieldProps, {}> {
    componentDidMount() {
        const textfield = (this.props.componentRef as React.RefObject<ITextField>).current;
        // move the cursor to the end
        textfield.setSelectionRange(textfield.value.length, textfield.value.length);
    }
    render() {
        return <TextField {...this.props} />;
    }
}

export const TextFieldWithCursorAtEnd = React.forwardRef(
    (props: ITextFieldProps, ref: React.RefObject<ITextField>): React.ReactElement<any> => {
        return <WithCursorAtEnd {...props} componentRef={ref} />;
    }
);
